import { io, type Socket } from "socket.io-client";
import { useAuthStore } from "@/store/authStore";

const WS_URL = import.meta.env.VITE_WS_URL || "http://localhost:3001";

let socket: Socket | null = null;

export function connectSocket(token: string): Socket {
  if (socket?.connected) return socket;

  socket = io(WS_URL, {
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on("connect", () => {
    const currentRooms = getJoinedRooms();
    if (currentRooms.length > 0 && socket) {
      socket.emit("rejoin", currentRooms);
    }
  });

  socket.on("disconnect", (reason) => {
    console.warn("Socket disconnected:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("Socket connection error:", err.message);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  joinedRooms.clear();
}

export function getSocket(): Socket | null {
  return socket;
}

const joinedRooms = new Set<string>();

export function joinRoom(roomId: string) {
  joinedRooms.add(roomId);
  if (socket?.connected) {
    const [type] = roomId.split(":");
    if (type === "dm") {
      const parts = roomId.split(":");
      socket.emit("dm:join", parts[1] === useAuthStore.getState().user?.id ? parts[2] : parts[1]);
    } else if (type === "group") {
      socket.emit("group:join", roomId.split(":")[1]);
    } else if (type === "channel") {
      socket.emit("channel:join", roomId.split(":")[1]);
    }
  }
}

export function leaveRoom(roomId: string) {
  joinedRooms.delete(roomId);
  if (socket?.connected) {
    const [type] = roomId.split(":");
    if (type === "dm") {
      const parts = roomId.split(":");
      socket.emit("dm:leave", parts[1] === useAuthStore.getState().user?.id ? parts[2] : parts[1]);
    } else if (type === "group") {
      socket.emit("group:leave", roomId.split(":")[1]);
    } else if (type === "channel") {
      socket.emit("channel:leave", roomId.split(":")[1]);
    }
  }
}

function getJoinedRooms(): string[] {
  return Array.from(joinedRooms);
}
